import { useEffect } from "react";

export default function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return;

    // Supprime l'ancien script s'il existe (évite les doublons en navigation SPA)
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [id, data]);
}
